import {
    Popover,
    PopoverArrow,
    PopoverBody,
    PopoverContent,
    PopoverTrigger,
    Portal,
    Text,
    VStack,
} from '@chakra-ui/react';

import { PasswordValidationItem } from '@/v5/components/molecules/Password/PasswordValidationItem';

function PasswordValidationPopover({
    initialFocusRef,
    isOpen,
    password,
    children,
}) {
    const hasLowercase = /[a-z]/.test(password);
    const hasUppercase = /[A-Z]/.test(password);
    const hasNumber = /\d/.test(password);
    const hasSpecialChar = /^(?=.*[!@#$%^&*()_+=[\]{};':"\\|,.<>/?-])/.test(
        password,
    );
    const hasNoForbiddenChars =
        password && !password.includes('<') && !password.includes('>');
    const hasMinLength = password && password.length >= 8;

    return (
        <Popover
            isLazy
            initialFocusRef={initialFocusRef}
            returnFocusOnClose={false}
            isOpen={isOpen}
            placement="left"
            closeOnBlur={false}>
            <PopoverTrigger>{children}</PopoverTrigger>
            <Portal>
                <PopoverContent width="300px">
                    <PopoverArrow />
                    <PopoverBody>
                        <VStack align="stretch" spacing={2}>
                            <Text fontWeight="bold" mb="6px">
                                Password Requirements
                            </Text>
                            <PasswordValidationItem isValid={hasMinLength}>
                                At least 8 characters
                            </PasswordValidationItem>
                            <PasswordValidationItem isValid={hasLowercase}>
                                One lowercase letter
                            </PasswordValidationItem>
                            <PasswordValidationItem isValid={hasUppercase}>
                                One uppercase letter
                            </PasswordValidationItem>
                            <PasswordValidationItem isValid={hasNumber}>
                                One number
                            </PasswordValidationItem>
                            <PasswordValidationItem isValid={hasSpecialChar}>
                                One special character
                            </PasswordValidationItem>
                            <PasswordValidationItem
                                isValid={hasNoForbiddenChars}>
                                No {'<'} or {'>'} characters
                            </PasswordValidationItem>
                        </VStack>
                    </PopoverBody>
                </PopoverContent>
            </Portal>
        </Popover>
    );
}

export { PasswordValidationPopover };
